<template>
  <transition name="fade" mode="out-in">
  <div v-if="withdrawScreen" class="ui inverted segment" key="withdraw">
    <div class="ui inverted header">
      {{ localisation.consent.withdrawConsent }}
    </div>
    <div v-html="localisation.consent.withdrawConfirmationBody" />
    <br>
    <button class="ui left floated tertiary circular button" @click="backFromWithdraw" :disabled="withdrawConfirmation || isLoading">{{ localisation.generic.back }}</button>
    <button class="ui right floated tertiary circular button" @click="attemptWithdrawConsent" :disabled="withdrawConfirmation || isLoading">{{ localisation.consent.withdrawConsent }}</button>
    <br>
    <br>
    <div v-if="isLoading" style="text-align: center; margin: 1rem 0"><i class="ui spinner loading icon"/></div>
      <div v-if="withdrawConfirmation" class="ui info message">
        {{ localisation.consent.successWithdrawMessage }}
      </div>
    <error-messages v-if="hasError" :errors="errorMessages"/>

  </div>

  <div v-else key="info">
    <div class=" ui inverted segment">
      <div class="ui inverted header">
        {{ localisation.studyName }}
        <div v-if="chosenStudy.requiresIdentifier" class="ui sub header">
          {{ localisation.studyIdentifier.studyIdentifierLabel }}: {{ userStudyIdentifier[chosenStudy.identifierAttribute] }}
        </div>
      </div>
      <div v-html="localisation.consent.consentSuccess" />
      <br>
      <div v-html="localisation.studyDescription" />
      <br>
      <button @click="goToWithdrawConsent" class="ui tertiary fluid circular button">{{ localisation.consent.withdrawConsent }}</button>
    </div>
    <div v-if="localisation.hasOwnProperty('contactInfo') && localisation.contactInfo !== ''" class="ui inverted small segment">
      {{ localisation.contactInfo }}
    </div>
  </div>

  </transition>
</template>

<script>
import Vue from 'vue'
import ErrorMessages from '@/components/ErrorMessages.vue'
import { mapActions } from 'vuex'

export default {
  name: 'Consent',
  components: {
    ErrorMessages
  },
  data () {
    return {
      withdrawScreen: false,
      withdrawConfirmation: false,
      isLoading: false,
      hasError: false,
      errorMessages: []
    }
  },
  computed: {
  },
  methods: {
    ...mapActions(['matchUserToStudy', 'updateBrazeConsent']),
    // rename this
    goToWithdrawConsent () {
      this.withdrawScreen = true
    },
    backFromWithdraw () {
      this.withdrawScreen = false
    },
    attemptWithdrawConsent () {
      this.isLoading = true
      this.hasError = false
      this.errorMessages = []
      this.matchUserToStudy(false).then(() => {
        this.updateBrazeConsent(false).then(() => {
        }).catch((error) => {
          console.log(error)
          Vue.Rollbar.error('Updating Braze attributes failed', error)
        })
        this.isLoading = false
        this.withdrawConfirmation = true
      }).catch((error) => {
        this.isLoading = false
        this.hasError = true
        this.errorMessages.push('genericMessage')
        console.log(error)
      })
    }
  }
}

</script>

<style scoped>
</style>
